/* Auto-generated, do not edit */
import React from 'react';

interface Props {
  size?: number | string;
  width?: number | string;
  height?: number | string;
  fill?: string;
}

function Avatar_icn_avatar13(props: Props) {
    const { size = 14, width = size, height = size, fill = '' } = props;
    return (
      <svg viewBox="0 0 24 24" fill="#27A2A8" width={ `${ width }px` } height={ `${ height }px` } ><path opacity=".3" d="M12 21h-2l-3-2-1-5-1-3 1-2V5l3-3h6l3 3v4l1 2-1 3-1 5-3 2h-2z"/><path d="M14 22h-4c-.197 0-.391-.059-.555-.168l-3-2a.999.999 0 0 1-.426-.636l-.988-4.939-.979-2.94a1.004 1.004 0 0 1 .054-.764L5 8.764V5c0-.266.105-.52.293-.707l3-3A.996.996 0 0 1 9 1h6c.266 0 .52.105.707.293l3 3A.996.996 0 0 1 19 5v3.764l.895 1.789c.118.237.138.512.054.764l-.979 2.94-.988 4.939c-.052.26-.205.488-.426.636l-3 2A1.011 1.011 0 0 1 14 22zm-3.697-2h3.395l2.403-1.603.919-4.594c.008-.04.019-.081.032-.12l.868-2.606-.814-1.63A.99.99 0 0 1 17 9V5.414L14.586 3H9.414L7 5.414V9c0 .155-.036.309-.105.447l-.814 1.63.868 2.606a.85.85 0 0 1 .032.12l.919 4.594L10.303 20z"/><path d="M13 8h-2c-.409 0-.776-.249-.929-.629l-2-5 1.857-.742L11.677 6h.646l1.748-4.371 1.857.742-2 5A1 1 0 0 1 13 8zM6.757 11.97l.485-1.94 4 1-.485 1.94zM12.757 11.03l4-1 .485 1.94-4 .999zM14.772 21.559 12.67 20h-1.34l-2.103 1.559-1.191-1.607 2.368-1.755A1 1 0 0 1 11 18h2c.215 0 .423.069.596.196l2.368 1.755-1.192 1.608z"/></svg>
  );
}

export default Avatar_icn_avatar13;
